import { Grid, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import { useTranslation } from "react-i18next";
import UsersTable from "./components/UsersTable";

const AdminUsers = () => {
  const { t } = useTranslation();

  return (
    <Box padding="24px">
      <Stack direction="column">
        <Grid display="flex" justifyContent="center" padding="24px 0">
          <Typography variant="h5">{t("adminUsers.usersOverview")}</Typography>
        </Grid>
        <UsersTable />
      </Stack>
    </Box>
  );
};
export default AdminUsers;
